import React, { useEffect, useState } from 'react'
import moment from 'moment'
import Radio from '@material-ui/core/Radio'
import { Formik, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import 'react-datepicker/dist/react-datepicker.css'
import DatePicker from 'react-datepicker'
import { updateSignOnOffTimes } from '../Store/actions'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

const TrucksShifts = props => {
  const {
    setUpdateSignOnOff,
    updateSignOnOff,
    setEnterSignOnOff,
    enterSignOnOff,
    handleRadioButton,
    checkedSignOnOffs,
    setCheckedSignOnOffs
  } = props

  const [initialSignOn, setInitialSignOn] = useState('')
  const [initialSignOff, setInitialSignOff] = useState('')

  useEffect(() => {
    if (checkedSignOnOffs.length === 1) {
      const soloSignOnOff = props.activeNow.signOnOffData.find(
        item => item._id === checkedSignOnOffs[0]
      )
      setInitialSignOn(new Date(soloSignOnOff.signOnTime))
      setInitialSignOff(new Date(soloSignOnOff.signOffTime))
    } else if (initialSignOn || initialSignOff) {
      setInitialSignOn('')
      setInitialSignOff('')
    }
  }, [checkedSignOnOffs.length]) // eslint-disable-line react-hooks/exhaustive-deps

  const cancelButton = (
    <div style={{ width: '48%' }}>
      <div
        style={{
          width: '100%',
          height: '40px',
          background: '#fff',
          boxShadow: '0px 1px 3px #00000029',
          borderRadius: '4px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
        onClick={() => {
          setUpdateSignOnOff(false)
          setEnterSignOnOff(false)
          setCheckedSignOnOffs([])
        }}
      >
        <span style={{ color: '#1565D8' }}>Cancel</span>
      </div>
    </div>
  )

  const updateSignOnOffs = values => {
    props.updateSignOnOffTimes(checkedSignOnOffs, values)
    setEnterSignOnOff(false)
    setCheckedSignOnOffs([])
  }

  return (
    <div style={{ paddingTop: enterSignOnOff ? '' : '24px' }}>
      {!enterSignOnOff && (
        <div
          style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            zIndex: 1
          }}
        >
          <div
            style={{
              margin: '0 8px 16px 8px',
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%'
            }}
          >
            {!updateSignOnOff && !enterSignOnOff && (
              <div
                style={{
                  width: '100%',
                  height: '40px',
                  background:
                    'transparent linear-gradient(0deg, #1665D8 0%, #1F6FE5 99%, #1F6FE5 100%) 0% 0% no-repeat padding-box',
                  boxShadow: '0px 1px 3px #00000029',
                  borderRadius: '4px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
                onClick={() => setUpdateSignOnOff(true)}
              >
                <span style={{ color: '#fff' }}>Sign On / Off</span>
              </div>
            )}

            {updateSignOnOff && (
              <>
                {cancelButton}
                <div style={{ width: '48%' }}>
                  <div
                    style={{
                      width: '100%',
                      height: '40px',
                      background: checkedSignOnOffs.length
                        ? 'transparent linear-gradient(0deg, #1665D8 0%, #1F6FE5 99%, #1F6FE5 100%) 0% 0% no-repeat padding-box'
                        : '#FFF',
                      boxShadow: '0px 1px 3px #00000029',
                      borderRadius: '4px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      pointerEvents: checkedSignOnOffs.length ? 'auto' : 'none'
                    }}
                    onClick={() => {
                      setUpdateSignOnOff(false)
                      setEnterSignOnOff(true)
                    }}
                  >
                    <span style={{ color: checkedSignOnOffs.length ? '#fff' : '#1565D8' }}>
                      Next
                    </span>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {!enterSignOnOff &&
        props.activeNow.signOnOffData.map((signOnOffEntry, i) => {
          return (
            <div key={i} style={{ display: 'flex' }}>
              {updateSignOnOff && (
                <div
                  style={{ display: 'flex' }}
                  onClick={() => handleRadioButton(signOnOffEntry._id)}
                >
                  <Radio
                    checked={checkedSignOnOffs.includes(signOnOffEntry._id)}
                    value={signOnOffEntry._id}
                    style={{ color: '#1565D8', padding: '0 16px 0 0' }}
                  />
                </div>
              )}
              <div style={i > 0 ? { marginTop: '16px', width: '100%' } : { width: '100%' }}>
                <div
                  style={{
                    height: '92px',
                    boxShadow: '0px 1px 3px #00000029',
                    borderRadius: '5px',
                    width: '100%'
                  }}
                >
                  <div
                    style={{
                      backgroundColor: '#F6F9FD',
                      height: '35px',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <span style={{ fontSize: '16px', color: '#3E3E41', paddingLeft: '16px' }}>
                      {signOnOffEntry.truckId} - {signOnOffEntry.firstName}{' '}
                      {signOnOffEntry.lastName}
                    </span>
                  </div>
                  <div style={{ display: 'flex', height: '52px' }}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '20%',
                        justifyContent: 'center',
                        paddingLeft: '16px',
                        borderRight: '1px solid #E7E7EC',
                        marginTop: '5px'
                      }}
                    >
                      <span style={{ fontSize: '12px', color: '#9FA0A5' }}>Sign On</span>
                      <span style={{ fontSize: '16px', color: '#3E3E41', paddingTop: '6px' }}>
                        {signOnOffEntry.signOnTime
                          ? moment(signOnOffEntry.signOnTime).format('HH:mm')
                          : '-'}
                      </span>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '20%',
                        justifyContent: 'center',
                        paddingLeft: '16px',
                        borderRight: '1px solid #E7E7EC',
                        marginTop: '5px'
                      }}
                    >
                      <span style={{ fontSize: '12px', color: '#9FA0A5' }}>Sign Off</span>
                      <span style={{ fontSize: '16px', color: '#3E3E41', paddingTop: '6px' }}>
                        {signOnOffEntry.signOffTime
                          ? moment(signOnOffEntry.signOffTime).format('HH:mm')
                          : '-'}
                      </span>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        paddingLeft: '16px',
                        marginTop: '5px',
                        width: '50%'
                      }}
                    >
                      <span style={{ fontSize: '12px', color: '#9FA0A5' }}>Scheduled Shift</span>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'flex-end'
                        }}
                      >
                        <span style={{ fontSize: '16px', color: '#3E3E41' }}>-</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      {enterSignOnOff && (
        <div>
          <Formik
            initialValues={{
              signOnTime: initialSignOn,
              signOffTime: initialSignOff
            }}
            validationSchema={TimeSchema}
            onSubmit={values => updateSignOnOffs(values)}
            render={({ values, handleBlur, handleSubmit, setFieldValue, isValid }) => (
              <form onSubmit={handleSubmit}>
                <div
                  style={{
                    margin: '0 22px'
                  }}
                >
                  <div style={{ marginBottom: '20px' }}>
                    <span
                      style={{
                        font: '12px Roboto',
                        color: '#9EA0A5',
                        marginBottom: '9px',
                        display: 'inline-block'
                      }}
                    >
                      Sign on time
                    </span>
                    <div>
                      <DatePicker
                        selectsStart
                        className="fullWidthMobileDatePicker"
                        name="signOnTime"
                        selected={values.signOnTime}
                        onChange={e => setFieldValue('signOnTime', e)}
                        showTimeSelect
                        showTimeSelectOnly
                        timeFormat="HH:mm"
                        timeIntervals={15}
                        dateFormat="HH:mm"
                        timeCaption="Time"
                        onBlur={handleBlur}
                        autoComplete="off"
                      />
                      <ErrorMessage
                        name="signOnTime"
                        render={msg => (
                          <span
                            style={{
                              position: 'absolute',
                              color: '#E6492D',
                              fontSize: '0.75rem'
                            }}
                          >
                            {msg}
                          </span>
                        )}
                      />
                    </div>
                  </div>
                  <div>
                    <span
                      style={{
                        font: '12px Roboto',
                        color: '#9EA0A5',
                        marginBottom: '9px',
                        display: 'inline-block'
                      }}
                    >
                      Sign off time
                    </span>
                    <div>
                      <DatePicker
                        selectsEnd
                        className="uik-input__input fullWidthMobileDatePicker"
                        onBlur={handleBlur}
                        name="signOffTime"
                        selected={values.signOffTime}
                        onChange={e => setFieldValue('signOffTime', e)}
                        showTimeSelect
                        showTimeSelectOnly
                        timeFormat="HH:mm"
                        timeIntervals={15}
                        dateFormat="HH:mm"
                        minTime={
                          values.signOnTime ||
                          moment()
                            .startOf('day')
                            .toDate()
                        }
                        maxTime={moment()
                          .endOf('day')
                          .toDate()}
                        autoComplete="off"
                      />
                      <ErrorMessage
                        name="signOffTime"
                        render={msg => (
                          <span
                            style={{
                              position: 'absolute',
                              color: '#E6492D',
                              fontSize: '0.75rem'
                            }}
                          >
                            {msg}
                          </span>
                        )}
                      />
                    </div>
                  </div>
                </div>

                {enterSignOnOff && (
                  <div
                    style={{
                      position: 'fixed',
                      bottom: 0,
                      left: 0,
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%',
                      zIndex: 1
                    }}
                  >
                    <div
                      style={{
                        margin: '0 8px 16px 8px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%'
                      }}
                    >
                      {cancelButton}
                      <div style={{ width: '48%' }}>
                        <button
                          type="submit"
                          style={{
                            width: '100%',
                            height: '40px',
                            background: isValid
                              ? 'transparent linear-gradient(0deg, #1665D8 0%, #1F6FE5 99%, #1F6FE5 100%) 0% 0% no-repeat padding-box'
                              : '#FFF',
                            boxShadow: '0px 1px 3px #00000029',
                            borderRadius: '4px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            border: 'none',
                            fontSize: '1rem',
                            color: isValid ? '#fff' : '#1565D8',
                            pointerEvents: isValid ? 'auto' : 'none'
                          }}
                        >
                          Finish
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </form>
            )}
          />
        </div>
      )}
      <div style={{ height: '50px' }} />
    </div>
  )
}

const mapDispatchToProps = dispatch => bindActionCreators({ updateSignOnOffTimes }, dispatch)

export default connect(
  null,
  mapDispatchToProps
)(TrucksShifts)

const TimeSchema = Yup.object()
  .shape({
    signOnTime: Yup.string().typeError(''),
    signOffTime: Yup.string().typeError('')
  })
  .atLeastOneOf(['signOnTime', 'signOffTime'])
